// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "p.side-nav-header[data-v-4bc7dfc0]{padding:0!important;font-size:12px;font-weight:400;color:#8b8b8b;opacity:.8;margin:0 0 0 8px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
